import { BdtBaseModel } from "./bdt-base.model";

export class BdtClaseModel extends BdtBaseModel {
    Id: number;
    Codigo: string;
    Acronimo: string;
    Nombre: string;
    Descripcion: string;
    TipoId: number;
}